import { ROUTE_NAME } from '@/lib/constant';
import { RouteConfig } from 'vue-router';

export default [
    {
        path: '/member/home',
        name: ROUTE_NAME.MEMBER,
        meta: {
            title: '等级',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => ({
            component: import(/* webpackChunkName: "lucky" */ '@/pages/member/home.vue'),
        }),
    },
] as RouteConfig[];
